import React, {useContext} from 'react';
import {ControlledFormContext} from "../ControlledForm";
import {Utils} from "../../../logic/reusable/Utils";

const SelectionInput = (props: SelectionProps) => {
    const {handleFormChange, formData} = useContext(ControlledFormContext)
    const {options, name, labelAbove, label} = props
    return (
        <div className={`atoms-inputs-selection ${labelAbove ? "above" : ""}`}>
            {label ? <label htmlFor={name}>{label}</label> : null}
            <select name={name} value={Utils.dynamicKeyAccess(formData, name)} onChange={handleFormChange}>
                <optgroup>
                    {
                        options.map((option) => {
                            return <option key={option.value} value={option.value}>{option.name}</option>
                        })
                    }
                </optgroup>
            </select>
        </div>

    );
}

export default SelectionInput;
